export const AmbassadorThird = {
  THIRD_TITLE: 'influential individuals who we can trust to:',
  DEVELOP_TITLE: 'Develop',
  DEVELOP_DESC:
    'Provide critical feedback on our products and services, to help us grow and innovate.',
  PROMOTE_TITLE: 'Promote',
  PROMOTE_DESC:
    'A willingness to give expert commentary to media on eyecare topics as a WALDO representative and an expert in the field.',
  EDUCATE_TITLE: 'Educate',
  EDUCATE_DESC:
    'An ability to share knowledge and expertise to a wide audience through social media channels.',
  THIRD_DESC:
    'As a WALDO ambassador, you won’t just be a partner, you’ll become an extension of our brand and our voice.',
};
